// extracted by mini-css-extract-plugin
module.exports = {"content":"cart-content_content__WVt5V","list-item":"cart-content_list-item__jp5_t","is-first-list-item":"cart-content_is-first-list-item__nKX1D"};